import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useUserProfileLogic } from './UserProfileLogic';
import BasicUserProfileSkin from './skins/BasicUserProfileSkin';

/**
 * 사용자 프로필 스킨 가능 컴포넌트 정의
 */
export const UserProfileSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.USER_PROFILE,
  name: '사용자 프로필',
  category: 'auth',
  supportsExternalSkins: true,
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicUserProfileSkin as any
  },
  useLogic: useUserProfileLogic as any,
  defaultProps: {
    title: '내 정보',
    showPassword: true,
    showPhone: true,
    showEmail: true,
    showBirthday: true,
    showAddress: true,
    buttonColor: '#007bff',
    titleColor: '#333333',
    labelColor: '#666666',
    componentProps: {
      skin: 'basic',
      title: '내 정보',
      showPassword: true,
      showPhone: true,
      showEmail: true,
      showBirthday: true,
      showAddress: true,
      buttonColor: '#007bff',
      titleColor: '#333333',
      labelColor: '#666666'
    },
    varFields: {
      var01: { show: false, label: "", type: "input" },
      var02: { show: false, label: "", type: "input" },
      var03: { show: false, label: "", type: "input" },
      var04: { show: false, label: "", type: "input" },
      var05: { show: false, label: "", type: "input" },
      var06: { show: false, label: "", type: "input" },
      var07: { show: false, label: "", type: "input" },
      var08: { show: false, label: "", type: "input" },
      var09: { show: false, label: "", type: "input" },
      var10: { show: false, label: "", type: "input" }
    }
  }
};